import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot,faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faInstagram, faLinkedin, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import {Link} from 'react-router-dom';
const LandingFooter = () => {
    return (
        <>
            <footer className="footer-area style-2 bg-light mt-6">
                <div className="container">
                    <div className="footer-area-inner">
                        <div className="row">
                            <div className='col-md-6'>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className="footer-widget-wrapper">
                                            <div className="footer-logo">
                                                <Link to="/">
                                                    <img src="/truvoice_logo-new.png" alt="site-logo"/>
                                                </Link>
                                            </div>
                                            <div className="description-text mt-5">
                                                <div className="text-wrapper">
                                                    <p className="text fs-5">Julien Innovations India Pvt Ltd is an AI company with deep expertise in Language Models, Speech Technologies, AI/ML, Data Science and Product Development.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-6' >
                                        <div className="footer-single-col" style={{margin:'auto', display:'table'}}>
                                            <h3 className='text-gray-700 mb-5 fs-1'>Quick links</h3>
                                            <ul className="list-unstyled footer-nav-list mb-lg-0 quick-links">
                                                {/* <li>
                                                    <Link to="#" className="text-gray-600 fs-5" style={{lineHeight:'30px'}}>
                                                        About Us
                                                    </Link>
                                                </li> */}
                                                <li>
                                                    <Link to="/contact" className="text-gray-600 fs-5" style={{lineHeight:'30px'}}>
                                                        Contact
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="careers" className="text-gray-600 fs-5" style={{lineHeight:'30px'}}>
                                                        Careers
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/terms-and-conditions" className="text-gray-600 fs-5" style={{lineHeight:'30px'}}>
                                                        Terms of Use
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" className="text-gray-600 fs-5" style={{lineHeight:'30px'}}>
                                                        News &amp; Media
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className="footer-single-col">
                                    <h3 className='text-gray-700 mb-10 fs-1'>Julien Innovations India Pvt. Ltd.</h3>
                                    <div className="col-md-12 col-lg-12  d-flex">
                                        <div className="col-md-4 col-lg-5">
                                            <h4 className="fs-6 text-gray-700 mb-4">India Office</h4>
                                            <ul className="list-unstyled footer-nav-list mb-lg-0">
                                                <li>
                                                    <a className='text-gray-600 fs-6 d-flex ' style={{lineHeight:'24px'}}>
                                                        <FontAwesomeIcon icon={faLocationDot} className='fs-3 text-primary me-2' /> 
                                                        <span className='mt-m5'>CIE, Vindhya C4, IIIT Hyderabad Campus, Gachibowli, Hyderabad, Telangana: 500032 </span>
                                                    </a>
                                                </li>
                                                <li className='mt-3'>
                                                    <a className='text-gray-600 fs-6 '>
                                                        <FontAwesomeIcon icon={faEnvelope} className='fs-3 text-primary me-2' />
                                                        <span className='mt-m5'>sales@truvoice.ai </span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="col-md-2 col-lg-2"></div>
                                        <div className="col-md-4 col-lg-5">
                                            <h4 className="fs-6 text-gray-700 mb-4 ">USA Office</h4>
                                            <ul className="list-unstyled footer-nav-list mb-lg-0">
                                                <li>
                                                    <a className='text-gray-600 fs-6 d-flex '>
                                                        <FontAwesomeIcon icon={faLocationDot} className='fs-3 text-primary me-2'/>  
                                                        <span className='mt-m5'>
                                                            2512 Gold Hill Ct, New Hill, NC - 27562, USA
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className='mt-3'>
                                                    <a className='text-gray-600 fs-6 d-flex '>
                                                        <FontAwesomeIcon icon={faEnvelope} className='fs-3 text-primary me-2'/> 
                                                        <span className='mt-m5'>sales@truvoice.ai</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="copyright-area-inner">
                        <ul className="social-links">
                            <li>
                                <Link to="https://www.facebook.com/TruVoiceAI" target="_blank">
                                    <i className="fa-brands fa-facebook-f fs-5"></i>
                                </Link>
                            </li>
                            <li>
                                <Link to="https://studio.youtube.com/channel/UC9VZoYLKPs3thKpDXsAfszw/videos/upload?filter=%5B%5D&sort=%7B%22columnType%22%3A%22date%22%2C%22sortOrder%22%3A%22DESCENDING%22%7D" target="_blank">
                                    <i className="fa-brands fa-youtube fs-5"></i>
                                </Link>
                            </li>
                            <li>
                                <Link to="https://www.linkedin.com/company/truvoice/" target="_blank">
                                    <i className="fa-brands fa-linkedin fs-5"></i>
                                </Link>
                            </li>
                        </ul>
                        <div className="copyright-text">
                            <p className="text fs-7">© {new Date().getFullYear()}{' '}
                                <Link to="#" className="text-gray-700 fs-5">
                                    Julien Innovations India Pvt. Ltd.
                                </Link>
                                All Rights Reserved.
                            </p>
                            {/* <p className="text fs-7">
                                Technology Partner
                                <Link to="https://softamassindia.com/" className="text-gray-700 fs-5 ms-1">
                                    Soft Amass India
                                </Link>
                            </p> */}
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default LandingFooter